import React, { useEffect, useMemo, useState } from "react";
import "./Documents.css";
import { useDispatch, useSelector } from "react-redux";
// import { fetchDocumentRequest } from "../../../../store/features/actions/documentActions";
import { fetchDocumentRequest } from "../../../../../store/features/actions/documentActions";
import GenericTableSkeleton from "../../../skeletons/tableSkeleton/genericTableSkeleton";
import GenericDocumentTableComp from "./genericDocumentTableComp";
import NoDataComp from "../../../genericComponents/uiElements/NoDataComp";
import OpportunityFilterContainer from "../../Opportunities/opportunityFilterContainer/OpportunityFilterContainer";
import IOSSpinner from "../../../../HtmlElements/IOSSpinner";
import { getVendorCompanyId } from "../../../../../services/commonService";

function toYYYYMMDD(dateInput) {
  let date;

  // Handle if input is a Date object
  if (dateInput instanceof Date) {
    date = dateInput;
  } else {
    // Try to parse using Date constructor (fallback)
    const parsed = new Date(dateInput);
    if (!isNaN(parsed.getTime())) {
      date = parsed;
    } else {
      return ""; // Invalid date
    }
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

const DocumentsV3 = ({
  competitorInfo,
  financialsDataCheck,
  setFinancialsDataCheck,
  dataReportCheck,
}) => {
  const { account_info } = useSelector((state) => state?.accountsReducer);
  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [documentsData, setDocumentsData] = useState([]);
  // const accountTicker = account_info?.ticker || "";
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector(
    (state) => state.documentReducer
  );

  const documents = useMemo(() => {
    setFinancialsDataCheck((prevState) => ({
      ...prevState,
      hasFinancialDocumentsData: data?.length && !loading,
    }));

    dataReportCheck("financialDocuments", data?.length && !loading);

    return {
      alldocs: data
        ?.map((doc) => ({
          ...doc,
          parsedFilingDate: toYYYYMMDD(doc?.filingDate),
        }))
        .sort(
          (a, b) => new Date(b.parsedFilingDate) - new Date(a.parsedFilingDate)
        ),
    };
  }, [data]);

  const filterCount = useMemo(
    () =>
      Object.values(filters).reduce((acc, val) => acc + (val?.length || 0), 0),
    [filters]
  );

  useEffect(() => {
    // Exit early if there's no data to process
    if (!documents?.alldocs?.length) return;

    // Define the keys we're interested in extracting values from
    const include = ["fileType"];

    // Initialize an object to collect unique filter values
    const options = {};
    // Loop through each opportunity item
    documents?.alldocs?.forEach((item) => {
      include?.forEach((key) => {
        const value = item[key];
        if (!value) return; // Skip if key doesn't exist or is null/undefined

        // Initialize a Set for the key if not already present
        options[key] = options[key] || new Set();

        // Special case: if key is "mapped_products", assume nested array structure
        if (key === "mapped_products") {
          let normalized = [];

          if (typeof value === "string") {
            // Split string by comma and trim whitespace
            normalized = value.split(",").map((v) => v.trim());
          } else if (Array.isArray(value)) {
            normalized = value;
          }

          normalized.forEach((val) => options[key].add(val));
        }
        // Handle general arrays
        else if (Array.isArray(value)) {
          value?.forEach((val) => options[key].add(val));
        }
        // Handle primitive or single string values
        else {
          options[key].add(value);
        }
      });
    });

    // Convert each Set to an array for easier use in dropdowns, filters, etc.

    const formatted = Object.entries(options).reduce((acc, [key, set]) => {
      acc[key] = [...set]?.filter((item) => item !== null || item != undefined);
      return acc;
    }, {});

    // Debug output
    // console.log("formatted", formatted);

    // Set the final structured filter options in state
    // console.log("formatted docs",formatted)

    // By default show only below type of files asked by Kaushik
    setFilters({
      fileType: [
        "10-K",
        "Earnings Call",
        "AR",
        "Shareholder or Analyst Call",
        "20-F",
        "Analyst or Investor Day",
        "Company Conference Presentation",
        "PR",
        "IP",
        "Guidance or Update Call",
      ],
    });

    setFilterOptions(formatted);
  }, [documents?.alldocs]);

  useEffect(() => {
    let filtered = documents?.alldocs?.filter((item) =>
      Object.entries(filters).every(([key, values]) => {
        // Handle mapped_products specially
        if (key === "mapped_products") {
          let val = item?.mapped_products;

          if (typeof val === "string") {
            val = val.split(",").map((v) => v.trim());
          } else if (!Array.isArray(val)) {
            val = [];
          }

          return val.some((v) => values.includes(v));
        }

        // Skip filter if no values selected
        if (!values?.length) return true;

        const val = item[key.toLowerCase()] ?? item[key];
        // console.log("values",values,val)
        return values.includes(val);
      })
    );
    // console.log("filtered data",filtered)

    setDocumentsData(filtered);
  }, [documents?.alldocs, filters]);

  // useEffect(() => {
  //   if (account_info?.company_code) {
  //     dispatch(fetchDocumentRequest(account_info?.company_code));
  //   }
  // }, [account_info?.company_code]);

  useEffect(() => {
    const vendorCompanyId = getVendorCompanyId(competitorInfo);
    dispatch(fetchDocumentRequest(vendorCompanyId));
  }, []);

  const formatDate = (dateInput = "1992-01-01", disableFormat = false) => {
    if (disableFormat) return dateInput;
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return dateInput;
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  if (error) return <div>Error loading documents</div>;

  if (loading) {
    return (
      <div className="container-fluid">
        <GenericTableSkeleton rowCount={15} colCount={4} />
      </div>
    );
  }

  if (data?.length === 0 && !loading) {
    return (
      <div className="container-fluid mt-2 mr-0 ml-0 pl-0 pr-0">
        <div class="future_bets_headblock">
          <div class="future_bets_subheadblock">
            <h5
              class="future_bets_head"
              style={{
                fontWeight: "600",
                fontSize: "13px",
                lineHeight: "17.5px",
                letterSpacing: "0%",
                color: "#000000",
              }}
            >
              Financial Documents
            </h5>
          </div>
        </div>
        <NoDataComp
          message={`${
            account_info?.company_type?.toLowerCase().includes("private")
              ? "This is a private company, so public filings aren’t available."
              : "No Documents Found"
          }`}
        />
      </div>
    );
  }

  if (data?.length > 0 && !loading) {
    return (
      <div className="container-fluid pl-0 pr-0">
        <div class="future_bets_headblock">
          <div class="future_bets_subheadblock">
            <h5
              class="future_bets_head"
              style={{
                fontWeight: "600",
                fontSize: "13px",
                lineHeight: "17.5px",
                letterSpacing: "0%",
                color: "#000000",
              }}
            >
              Financial Documents
            </h5>
          </div>
        </div>

        <div className="mt-3">
          <OpportunityFilterContainer
            filterOptions={filterOptions}
            filters={filters}
            setFilters={setFilters}
            type="spot"
            filterTitl="Filter Documents by File type. "
            disableButton={true}
          />
        </div>
        <span className="find-opportunities-header mt-3">
          <h6 className="find-opportunities-results-title">
            Showing {loading ? <IOSSpinner /> : documentsData?.length || 0}{" "}
            Results
          </h6>

          {filterCount > 0 && (
            <div className="find-opportunities-results-title-filter-badge">
              {filterCount} filters applied
              <img
                src="/img/x.png"
                alt="clear"
                onClick={() => setFilters({})}
              />
            </div>
          )}
        </span>
        <GenericDocumentTableComp
          documents={documentsData}
          formatDate={formatDate}
          title={"All Documents"}
        />
      </div>
    );
  }

  return null; // fallback render
};

export default React.memo(DocumentsV3);
